import { useCallback, useEffect, useState } from 'react'

import { Button, Stack } from '@mui/material'

import CheckIcon from '@mui/icons-material/Check'

import { t } from 'i18next'

import errorHandlerHook from '@hooks/useErrorHandler'

import GlobalSettingService from '@services/global-setting'

import { TLGTypography } from '@components/TLGTypography'

import { IRequestDemoUrls } from '@utils/types'

import { containerSx, subtitleSx, titleSx } from './styles'

const DemoSection = () => {
  const { handleError } = errorHandlerHook.useErrorHandler()

  const [requestDemoUrls, setRequestDemoUrls] = useState<IRequestDemoUrls>()

  const fetchRequestDemoUrls = useCallback(async () => {
    try {
      const response = await GlobalSettingService.getRequestDemoUrls()

      setRequestDemoUrls(response)
    } catch (err) {
      handleError({ exception: err })
    }
  }, [handleError])

  useEffect(() => {
    fetchRequestDemoUrls()
  }, [fetchRequestDemoUrls])

  return (
    <Stack sx={containerSx}>
      <TLGTypography responsiveVariant={{ xs: 'h5', md: 'h4' }} sx={titleSx}>
        {t("Unlock Your Potential with The Launchpad's Innovative Platform!")}
      </TLGTypography>
      <TLGTypography
        responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}
        sx={subtitleSx}
      >
        {t(
          "Experience the power of advanced matchmaking, actionable leads, and stay at the forefront of innovation. Get started now to unlock the full potential of The Launchpad's innovative platform."
        )}
      </TLGTypography>
      {requestDemoUrls && (
        <Button
          data-testid="book-demo-now-button"
          href={requestDemoUrls?.techVendorRequestDemoUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          color="secondary"
          size="medium"
          endIcon={<CheckIcon />}
        >
          {t('Book a Demo Now')}
        </Button>
      )}
    </Stack>
  )
}

export { DemoSection }
